let truncate = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str
  }

  return str.slice(0, maxLength - 3) + '...'
}

let truncateWithSuffix = (str, maxLength) => {
  if (str.length <= maxLength) {
    return str
  }

  const match = str.match(/\(([^)]+)\)$/)
  const suffix = match ? match[0] : ''
  const coreLength = maxLength - suffix.length - 4
  if (coreLength > 0) {
    return str.slice(0, coreLength) + '... ' + suffix
  }

  return str.slice(0, maxLength - 3) + '...'
}

export { truncate, truncateWithSuffix }